export function initKeyboardViewport() {
  const visualViewport = window.visualViewport;

  if (!visualViewport) {
    console.error('No visual viewport found');
    // fallback and set the keyboard offset to 0px
    document.documentElement.style.setProperty('--keyboard-offset', '0px');
    return;
  }

  const handleResize = () => {
    const keyboardOffset = Math.max(0, window.innerHeight - visualViewport.height);
    document.documentElement.style.setProperty('--keyboard-offset', `${keyboardOffset}px`);
  };

  visualViewport.addEventListener('resize', handleResize);
  visualViewport.addEventListener('scroll', handleResize);

  // Initial check
  handleResize();

  // Optional: return cleanup function if needed
  return () => {
    visualViewport.removeEventListener('resize', handleResize);
    visualViewport.removeEventListener('scroll', handleResize);
  };
}

initKeyboardViewport();
